import { z } from "zod";

export const CreateProviderSchema = z.object({
  name: z.string().min(1, "Nom requis"),
});

export type CreateProviderDto = z.infer<typeof CreateProviderSchema>;

export const CreateProviderZoneSchema = z.object({
  country: z.string().min(1, "Pays requis"),
  currency: z.string().min(1, "Devise requise"),
  priority: z.number().min(1, "Priorité requise"),
  providerId: z.string().min(1, "Fournisseur requis"),
});

export type CreateProviderZoneDto = z.infer<typeof CreateProviderZoneSchema>;

export const UpdateProviderZoneSchema = CreateProviderZoneSchema.partial();

export type UpdateProviderZoneDto = z.infer<typeof UpdateProviderZoneSchema>;

export const paymentProviderSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type PaymentProvider = z.infer<typeof paymentProviderSchema>;

export const ProviderZoneSchema = z.object({
  id: z.string(),
  country: z.string(),
  currency: z.string(),
  priority: z.number(),
  isActive: z.boolean(),
  provider: paymentProviderSchema,
});

export type ProviderZone = z.infer<typeof ProviderZoneSchema>;

export const ProvidersListSchema = z.object({
  page: z.number(),
  data: z.array(paymentProviderSchema),
});

export type ProvidersList = z.infer<typeof ProvidersListSchema>;

export const ProviderZonesListSchema = z.object({
  data: z.array(ProviderZoneSchema),
});

export type ProviderZonesList = z.infer<typeof ProviderZonesListSchema>;
